module.exports = __webpack_public_path__ + "static/media/Nota empieza la temporada de NFL.5f021bb6.png";